import { render } from "./AboutClientForm.vue?vue&type=template&id=5df824a5"
import script from "./AboutClientForm.vue?vue&type=script&lang=js"
export * from "./AboutClientForm.vue?vue&type=script&lang=js"

import "./AboutClientForm.vue?vue&type=style&index=0&id=5df824a5&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.4.2__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__